/**
 * Box Component Variants
 *
 * CVA variants for the Box component.
 */

import { cva } from 'class-variance-authority';

export const boxVariants = cva('', {
  variants: {
    /**
     * Padding variants
     */
    padding: {
      none: 'p-0',
      xs: 'p-2',
      sm: 'p-3',
      md: 'p-4',
      lg: 'p-6',
      xl: 'p-8',
    },
    /**
     * Border variants
     */
    border: {
      none: '',
      default: 'border border-border',
      subtle: 'border border-border/50',
      strong: 'border-2 border-border',
    },
  },
  defaultVariants: {
    padding: 'none',
    border: 'none',
  },
});
